module.exports = __webpack_public_path__ + "img/Attrape_reve.243c533.jpg";